<div class="flex-container">
  @if (is3aPillar) {
    <app-setup-risk-3a [hidden]="tabSelected > 3"></app-setup-risk-3a>
    <app-setup-3a-portfolio *ngIf="tabSelected > 3" [step]="step"></app-setup-3a-portfolio>
  } @else {
    <app-setup-investment *ngIf="tabSelected === 2"></app-setup-investment>
    <app-setup-risk-ch [hidden]="tabSelected !== 3"></app-setup-risk-ch>
    <app-setup-strategy-review *ngIf="tabSelected > 3" [step]="step"></app-setup-strategy-review>
  }
</div>

<app-dialog-generating-spinner *ngIf="riskToStrategyLoader$ | async">
  <p>
    {{ 'loadPortfolio.spinner.1.title' | translate }}
  </p>
  <p>
    {{ 'loadPortfolio.spinner.1.p1' | translate }}
  </p>
</app-dialog-generating-spinner>
